export default __webpack_public_path__ + "static/media/logo.cc224b7c.png";